export let xToY = {};
for (let i = 0; i <= 100; i++) xToY[i] = 0;